<!--
 * @Description  : 网站维护 -- 网站banner维护
 * @Author       : lxd
 * @Date         : 2022-04-24 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-09-16 16:10:40
 * @FilePath     : \ngs_platform_manage_admin\src\views\website\banner-list.vue
-->
<template>
	<div class="h100 operation-layout pd0">
		<!-- 列表查询页 -->
		<filter-layout @search="searchResult" @reset="resetForm" v-if="!routeQuery" :hasHeader="false">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="100px">
					<el-form-item label="应用项目：" prop="companyType">
						<el-select v-model="searchForm.scope" size="small">
							<el-option v-for="(item, index) in yyxm" :key="index" :label="item.scopeName" :value="item.scope"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间：" prop="dateArr">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="创建人：" prop="createUserName">
						<el-input size="small" v-model="searchForm.createUserName" placeholder="请输入姓名"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计设置： <span class="blue">{{ qyTotal }}</span> 项
						</div>
						<div class="btnGroups">
							<el-button type="primary" class="ml5 btn-blue" size="mini" @click="addConfig('add')">
								新增配置
							</el-button>
						</div>
					</div>

					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table
								:data="tableObj.tableData"
								border
								ref="qyTable"
								highlight-current-row
								v-loading="tableObj.loading"
								@row-click="onRowClick"
								height="100%"
							>
								<el-table-column type="index" label="序号" width="60" header-align="center" align="center"> </el-table-column>
								<el-table-column prop="scopeName" label="应用项目" min-width="270" header-align="center"></el-table-column>
								<el-table-column prop="remark" label="应用备注" min-width="270" header-align="center"> </el-table-column>
								<el-table-column prop="createUser" label="创建人" width="130" align="center"></el-table-column>
								<el-table-column prop="createDate" label="创建时间" width="165" align="center"></el-table-column>
								<el-table-column prop="isUse" label="配置启用/关闭" width="160" align="center">
									<template slot-scope="scope">
										<el-switch
											class="switchStyle"
											:value="scope.row.isUse"
											active-color="#409EFF"
											inactive-color="#dcdfe6"
											:active-value="1"
											:inactive-value="0"
											active-text="启用"
											inactive-text="关闭"
											@input="addConfig('change', scope.row)"
										>
										</el-switch>
									</template>
								</el-table-column>
								<el-table-column label="操作" align="center" min-width="150">
									<template slot-scope="scope">
										<el-button type="primary" size="mini" @click="toDetail(scope.row)">
											{{ scope.row.isUse == 0 ? '编辑' : '查看' }}
										</el-button>
										<el-button
											:type="scope.row.isUse == 0 ? 'danger' : 'info'"
											:disabled="scope.row.isUse == 0 ? false : true"
											size="mini"
											@click="addConfig('del', scope.row)"
										>
											删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageForm.current"
								:page-sizes="[10, 20, 50]"
								:page-size="pageForm.pagesize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="pageForm.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<banner-edit v-else></banner-edit>

		<!-- 配置弹窗 -->
		<el-dialog
			:visible.sync="tagsDialog.visible"
			class="primary-dialog"
			:width="tagsDialog.width"
			:title="tagsDialog.title"
			:close-on-click-modal="false"
			@closed="handleClosed"
			center
		>
			<div v-if="tagsDialog.type == 'add'">
				<el-row :gutter="40">
					<el-col :span="6" v-for="(item, i) in yyxm" :key="i">
						<el-radio v-model="scopeId" :label="item.scope" :disabled="item.isUse == 1">{{ item.scopeName }}</el-radio>
					</el-col>
				</el-row>
			</div>

			<div v-if="tagsDialog.type == 'del'">
				<div class="delClass">请再次确认需要删除该配置内容！</div>
				<div class="tishi">温馨提示：非网站管理人员，请勿进行此操作</div>
			</div>

			<div v-if="tagsDialog.type == 'change'">
				<div class="delClass" v-if="objectData.isUse == 0">
					请确定开启配置，开启后
					<span class="comColor"> {{ objectData.scopeName }} </span>栏目相关的图片将被替换
				</div>
				<div class="delClass" v-else>
					请确定关闭配置，关闭后<span class="comColor"> {{ objectData.scopeName }} </span>栏目相关的图片将无法浏览
				</div>
				<div class="tishi">温馨提示：非网站管理人员，请勿进行此操作</div>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button class="btn" size="small" @click="tagsDialog.visible = false" v-if="tagsDialog.type != 'add'">
					取 消
				</el-button>
				<el-button
					type="primary"
					size="small"
					class="btn btn-blue"
					:loading="btnLoading"
					v-if="tagsDialog.type == 'change'"
					@click="changeButton"
				>
					确定
				</el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" v-if="tagsDialog.type == 'del'" @click="delButton">
					确定
				</el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" @click="saveGo" v-if="tagsDialog.type == 'add'">
					下一步
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import BannerEdit from './components/banner-edit'
import { getListData, getSelectData, changeState, deleItem } from 'api/modules/website'
import { Snowflake } from 'node-snowflake'
export default {
	name: 'banner-list',
	components: {
		BannerEdit
	},
	data() {
		return {
			searchForm: {
				scope: '',
				endTime: '',
				dateArr: [],
				startTime: '',
				createUserName: ''
			},
			pageForm: {
				current: 1, //当前页
				pagesize: 10, //每页条数
				total: 0 //总条数
			},
			tableObj: {
				loading: false,
				tableData: [], //表格数据数组
				height: 400
			},
			qyTotal: 0,
			searchToggle: true,
			// companyObj: {
			//   adminName: "",
			//   phone: "",
			//   createDate: "",
			//   isReal: "",
			//   openSysNames: ""
			// },
			tableShow: true,
			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
			// 标签相关
			btnLoading: false,
			curRowId: '',
			tagsDialog: {
				visible: false,
				width: '740px',
				title: '',
				type: ''
			},
			scopeId: null, //单选参数
			yyxm: [], //下拉选项数据
			objectData: {} //点击按钮获取的数据
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('pageForm')) {
				this.pageForm = JSON.parse(this.$getSessionItem('pageForm'))

				// 移除 避免污染
				this.$removeSessionItem('pageForm')
			}
			this.getPlatFormTenants()
		}

		this.getPlatFormTenants()
		this.getSelectData()
	},
	methods: {
		//查看banner详情 编辑
		toDetail(item) {
			this.$router.push({
				query: {
					scope: item.scope,
					// scopeId: item.id,
					id: item.id,
					isUse: item.isUse,
					type: 'edit'
				}
			})
		},
		//新增配置
		saveGo() {
			if (!this.scopeId) {
				this.$message.warning('请选择应用项目！')
				return
			}

			this.yyxm.forEach((item) => {
				if (item.scope.includes(this.scopeId)) {
					changeState({
						scopeId: item.id,
						id: ''
					})
						.then((d) => {
							this.tagsDialog.visible = false
							this.$router.push({
								query: {
									scope: item.scope,
									scopeId: item.id,
									id: d.data,
									isUse: item.isUse,

									type: 'edit'
								}
							})
						})
						.catch((err) => {})
				}
			})
		},
		//下拉 新增配置数据
		getSelectData() {
			getSelectData({
				insertType: 0 // 新增类型 配置类型 0：网站banner维护；1：网站侧广告维护
			})
				.then((d) => {
					this.yyxm = d.data
				})
				.catch((err) => {})
		},
		//修改banner数据状态
		changeButton() {
			changeState({
				id: this.objectData.id,
				status: this.objectData.isUse == 0 ? 1 : 0
			})
				.then((d) => {
					this.tagsDialog.visible = false
					this.tagsDialog.type = ''
					this.getPlatFormTenants()
				})
				.catch((err) => {})
		},
		//删除列表数据
		delButton() {
			deleItem({
				id: this.objectData.id
			})
				.then((d) => {
					this.tagsDialog.visible = false
					this.tagsDialog.type = ''
					this.getPlatFormTenants()
				})
				.catch((err) => {})
		},
		// 每页条数改变时
		handleSizeChange(pageSize) {
			this.pageForm.pagesize = pageSize
			this.getPlatFormTenants()
		},

		// 当前页改变时
		handleCurrentChange(current) {
			this.pageForm.current = current
			this.getPlatFormTenants()
		},

		// 获取所有banner列表
		getPlatFormTenants() {
			let params = Object.assign({}, this.searchForm)
			// 时间段数据处理
			params.startTime = params.dateArr && params.dateArr.length > 0 ? params.dateArr[0] : ''
			params.endTime = params.dateArr && params.dateArr.length > 0 ? params.dateArr[1] : ''

			// 分页参数
			params.current = this.pageForm.current
			params.size = this.pageForm.pagesize
			params.selectType = 0 // 配置类型 0：网站banner维护；1：网站侧广告维护

			this.tableObj.loading = true
			getListData(params)
				.then((d) => {
					this.pageForm.total = parseInt(d.data.total)
					this.tableObj.tableData = d.data.records
					this.qyTotal = parseInt(d.data.total)
					this.tableObj.loading = false
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 搜索
		searchResult() {
			this.pageForm.pagesize = 10
			this.pageForm.current = 1
			this.getPlatFormTenants()
		},

		// 条件筛选重置
		resetForm() {
			this.pageForm.pagesize = 10
			this.pageForm.current = 1
			this.searchForm.scope = ''
			this.searchForm.endTime = ''
			this.searchForm.startTime = ''
			this.searchForm.dateArr = []
			this.searchForm.createUserName = ''
			this.getPlatFormTenants()
		},

		// 查看详情页返回
		// goBack() {
		//   this.$router.push({
		//     path: "/settled-enterprises"
		//   });
		// },

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.endTime
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.startTime
					if (startTime) {
						let nowTime = Date.now()

						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 行点击事件
		onRowClick(row) {
			this.curRowId = row.id
		},
		// 弹窗开启
		addConfig(type, item) {
			if (type == 'add') {
				this.tagsDialog.title = '选择应用项目'
				this.tagsDialog.width = '740px'
				this.$nextTick(() => {
					this.getSelectData()
				})
			} else {
				this.tagsDialog.title = '提醒'
				this.tagsDialog.width = '600px'
				this.objectData = item
			}
			this.tagsDialog.type = type
			this.tagsDialog.visible = true
		},
		// 弹窗关闭
		handleClosed(needRefresh) {
			this.tagsDialog.visible = false
			this.tagsDialog.type = ''

			// 刷新
			needRefresh ? this.getPlatFormTenants() : ''
		}
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.qyTable.doLayout()
			}, 1000)
		}
	}
}
</script>
<style lang="less" scoped>
.delClass {
	font-size: 16px;
	margin-bottom: 16px;
}

.tishi {
	font-size: 12px;
	color: #409eff;
}

.comColor {
	color: #409eff;
}

.settled-enterprises-layout {
	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.settled-enterprises-head {
		padding: 10px 20px 0 20px;

		.breadcrumb-list {
			padding: 0 15px;
			border: 1px solid #ddd;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
		}

		/deep/ .el-breadcrumb__item {
			height: 35px;
			line-height: 35px;
		}

		.el-icon-location {
			color: #009900;
			font-size: 18px;
		}

		.content-head {
			padding-bottom: 20px;
		}

		.right-align {
			text-align: right;
		}
	}

	.settled-enterprises-content {
		height: calc(100% - 50px);
		padding: 0 20px;

		.content {
			height: calc(100% - 220px);
		}
	}

	.qy-number {
		display: inline-block;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		font-size: 14px;
		border-left: 3px solid #2671cc;

		.blue {
			color: #2671cc;
			font-size: 18px;
			margin-right: 5px;
		}
	}

	.search-from {
		margin-bottom: 10px;
		border-bottom: 1px solid #2671cc;
	}

	.red {
		color: red;
	}

	.view-msg {
		color: #2671cc;
		cursor: pointer;
	}

	.ml25 {
		margin-left: 25px;
	}

	.icon {
		width: 20px;
		height: 20px;
		margin-right: 20px;
		color: #ccc;
	}

	.blue {
		color: #2671cc;
	}

	.purple {
		color: #ae5da1;
	}

	.blue-invoice {
		color: #2671cc;
	}

	.width25 {
		width: 25px;
	}

	.height25 {
		height: 25px;
	}
}

.pd0 {
	padding: 0 !important;
}
</style>

<style lang="less" scoped>
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}

.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	// /deep/ .el-dialog__body {
	//   padding: 30px;
	// }

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}

/deep/.switchStyle {
	.el-switch__label {
		position: absolute;
		display: none;
		color: #fff;

		span {
			font-size: 11px !important;
		}
	}

	.el-switch__label--left {
		z-index: 9;
		left: 6px;
	}

	.el-switch__label--right {
		z-index: 9;
		left: -9px;
	}

	.el-switch__label.is-active {
		display: block;
	}

	.el-switch,
	.el-switch__core,
	.el-switch,
	.el-switch__label {
		width: 53px !important;
	}
}

/deep/.el-radio {
	margin-left: 0 !important;
	margin-bottom: 16px;
}
</style>
